import {
  buscarNumeroProcessoEdicao,
  buscarNumeroProcessoNovo,
  buscarNumeroProcessoReserva
} from '@/controllers/processo/numeroProcesso'

import {
  buscarProcessoEdicao, buscarProcessoNovo, criarModeloProcesso,
  editarProcesso, salvarProcessoReservado, salvarNovoProcesso, retornarProcesso
} from '@/controllers/processo/processo'

import {
  criarNovoDocumento
} from '@/controllers/processo/documento'

const dictionary = {
  BUSCAR_NUMERO_PROCESSO_EDICAO: buscarNumeroProcessoEdicao,
  BUSCAR_NUMERO_PROCESSO_NOVO: buscarNumeroProcessoNovo,
  BUSCAR_NUMERO_PROCESSO_RESERVA: buscarNumeroProcessoReserva,
  BUSCAR_NUMERO_PROCESSO_MODELO: buscarNumeroProcessoNovo,

  BUSCAR_PROCESSO_EDICAO: buscarProcessoEdicao,
  BUSCAR_PROCESSO_NOVO: buscarProcessoNovo,
  BUSCAR_PROCESSO_RESERVA: buscarProcessoNovo,
  BUSCAR_PROCESSO_MODELO: criarModeloProcesso,

  PERSISTIR_PROCESSO_EDICAO: editarProcesso,
  PERSISTIR_PROCESSO_NOVO: salvarNovoProcesso,
  PERSISTIR_PROCESSO_RESERVA: salvarProcessoReservado,
  PERSISTIR_PROCESSO_MODELO: salvarNovoProcesso,

  POS_PERSISTIR_PROCESSO_EDICAO: retornarProcesso,
  POS_PERSISTIR_PROCESSO_NOVO: criarNovoDocumento,
  POS_PERSISTIR_PROCESSO_RESERVA: retornarProcesso,
  POS_PERSISTIR_PROCESSO_MODELO: retornarProcesso
}

export const getNumeroProcesso = async (numeroProcesso, tipo = 'BUSCAR_NUMERO_PROCESSO_EDICAO') => {
  return dictionary[tipo](numeroProcesso)
}

export const getProcesso = async (numeroProcesso, numeroProcessoObjeto = {}, tipo = 'BUSCAR_PROCESSO_EDICAO') =>
  dictionary[tipo](numeroProcesso, numeroProcessoObjeto)

export const buscarProcesso = async (tipo, numeroProcesso) => {
  var tipoNumeroProcesso = `BUSCAR_NUMERO_PROCESSO_${tipo}`
  var tipoProcesso = `BUSCAR_PROCESSO_${tipo}`

  return getNumeroProcesso(numeroProcesso, tipoNumeroProcesso)
    .then((numeroProcessoObjeto) => {
      return getProcesso(numeroProcesso, numeroProcessoObjeto, tipoProcesso)
    })
    .then((processo) => {
      return processo
    })
}

export const persistirProcesso = async (tipo) => {
  var tipoPersitencia = `PERSISTIR_PROCESSO_${tipo}`
  var tipoPosPersitencia = `POS_PERSISTIR_PROCESSO_${tipo}`

  return dictionary[tipoPersitencia]().then(processo => {
    return dictionary[tipoPosPersitencia](processo)
  })
}

export const RESERVA = 'RESERVA'
export const EDICAO = 'EDICAO'
export const NOVO = 'NOVO'
export const MODELO = 'MODELO'
